import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 期貨交易知識認知確認表
 */
const FuturesKnowledgePostBack = [
    'POST',
    RouteUrlList.API_FuturesKnowledgePostBack.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default FuturesKnowledgePostBack;
